import moment from 'moment-timezone';

/**
 * Providers for which scheduled orders use adjusted Be Ready Time (Scheduled Time − offset).
 */
export const BE_READY_OFFSET_PROVIDERS = ['food3', 'food2'];

/**
 * For scheduled orders from Food3 or Food2: Be Ready Time is displayed this many minutes
 * earlier than the scheduled time.
 */
export const BE_READY_OFFSET_MINUTES = 17;

/**
 * Returns the Be Ready Time to display for an order.
 * For scheduled DELIVERY orders from Food3 or Food2, returns Scheduled Time − 17 minutes.
 * Otherwise returns the original beReadyTime.
 *
 * @param {Object} params
 * @param {string} params.beReadyTime - Original be ready time (ISO string or moment-acceptable)
 * @param {boolean} params.isScheduled - Whether the order is scheduled
 * @param {string} params.provider - Order provider (e.g. 'food3', 'food2')
 * @param {string} [params.type] - Order type (e.g. 'delivery', 'take_out'); adjustment applies only for 'delivery'
 * @param {{ endTime?: string }} [params.dropOffTimeRange] - Optional; endTime is the scheduled time
 * @returns {string} ISO string for the display value (for use with moment.utc(...).tz(...))
 */
export function getDisplayBeReadyTime({
  beReadyTime,
  isScheduled,
  provider,
  type,
  dropOffTimeRange,
}) {
  if (!beReadyTime) {
    return beReadyTime ?? '';
  }
  const providerName = provider?.toLowerCase?.();
  const isScheduledDeliveryFromFood2OrFood3 =
    isScheduled &&
    type === 'delivery' &&
    provider &&
    BE_READY_OFFSET_PROVIDERS.includes(providerName);

  if (!isScheduledDeliveryFromFood2OrFood3) {
    return beReadyTime;
  }

  const scheduledTime = dropOffTimeRange?.endTime || beReadyTime;

  return moment
    .utc(scheduledTime)
    .subtract(BE_READY_OFFSET_MINUTES, 'minutes')
    .toISOString();
}
